import axios from "axios";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { carruselDTO } from "../../components/Carrusel/Carrusel.model";
import { pathImages, webApiCarrusel } from "../../routes/endpoints";
import { Carousel } from 'react-bootstrap';
import { propsHome } from "../../models/Home.model";
import {ErrorBoundary} from "react-error-boundary";
import ErrorMessageNotifications from "../../components/Errores/ErrorMessageNotifications";

export default function Main(props: propsHome) {
    const [elementos, setElementos] = useState<carruselDTO[]>([]);    
    useEffect(()=>{         
        axios.post(webApiCarrusel, {seccion:props.seccion} ).then((response) => {
            setElementos(response.data)            
        }).catch(err => console.warn(err));         
    },[props.seccion]); 

        return( 
            <>
            {/* { (!elementos.length) && <div id="carruselPortada" className="carousel slide" data-bs-ride="carousel"><Loading/></div>  } */}
                <div className="container-fluid px-0">
                    <div id="carru" className="d-flex justify-content-center" data-bs-ride="carousel">
                    <ErrorBoundary FallbackComponent={ErrorMessageNotifications}> 
                        <Carousel 
                            variant="dark" 
                            indicators={false} 
                            className="carrousel_size"
                            nextIcon={<span aria-hidden="true" className="carousel-control-next-icon next_control_right" />}
                            prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon next_control_left" />}>
                        { elementos.length !== undefined  && elementos.length > 0 &&  
                            elementos.map( ({id, imagen, titulo, texto,url }, i) => (
                                <Carousel.Item key={i} className="next_control_right p-0">
                            { (url !== '' && url !== null)? 
                                <Link to={{pathname:url}}  target="_blank">
                                <img className="d-block w-100 images-carrusel" src={`${pathImages}${imagen}`} alt="slide"/>
                                </Link>
                                :
                                <img className="d-block w-100 images-carrusel" src={`${pathImages}${imagen}`} alt="slide"/>
                            }
                                <Carousel.Caption>
                                    {/* <h3>{titulo}</h3> */}
                                </Carousel.Caption>
                                </Carousel.Item>                                
                            ))
                        }
                        </Carousel> 
                        </ErrorBoundary> 
                    </div>
                </div>
            </>
        )
    
}
